// extracted by mini-css-extract-plugin
export default {"container":"statisticDashboard_container__aldLs"};